import { render, staticRenderFns } from "./contactform.vue?vue&type=template&id=6398b278&scoped=true&"
import script from "./contactform.vue?vue&type=script&lang=js&"
export * from "./contactform.vue?vue&type=script&lang=js&"
import style0 from "./contactform.vue?vue&type=style&index=0&id=6398b278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398b278",
  null
  
)

export default component.exports